import { useQuery } from '@tanstack/react-query';
import { useConfig } from '@sgi/af-shell-shared';
import { sgiClient } from 'src/services/sgiClient';
import { queryKeys } from 'src/utils/keys';

export const useSearchDriverByCustomerNumber = (customerNumber: string) => {
  const { REACT_APP_BFF_API_BASEURL } = useConfig();
  return useQuery({
    queryKey: [REACT_APP_BFF_API_BASEURL, queryKeys.driver, customerNumber],
    queryFn: async () => await searchByCustomerNumber(REACT_APP_BFF_API_BASEURL, customerNumber),
  });
};

async function searchByCustomerNumber(baseUrl: string, customerNumber: string) {
  const result = await sgiClient.driver.searchByCustomerNumber(baseUrl, customerNumber);
  if (result && result.length > 0) {
    return result[0];
  }
  return null;
}
